module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fd0765acc2eb99d7f88d1a1b236d10c2.png";